<div class="hyperkit-card">
  <ng-content></ng-content>
</div>
